import Domain from '@/api/domain'

export default {
  namespaced: true,
  state: {
    jobTypes: [],
    categories: [],
    jobTypesReward: {},
    jobTypesBackup: []
  },
  mutations: {
    setJobTypes (state, jobTypes) {
      state.jobTypes = jobTypes
    },
    setCategories (state, categories) {
      state.categories = categories
    },
    setJobTypesReward (state, jobTypesReward) {
      state.jobTypesReward = jobTypesReward
    },
    setJobTypesBackup (state, jobTypes) {
      state.jobTypesBackup = jobTypes
    },
    setJobTypesZero (state) {
      const jobs = state.jobTypes.map(item => ({
        ...item,
        rewardPercentage: 0
      }))
      let jobTypesReward = {}
      if (jobs.length > 0) {
        jobs.forEach(item => {
          jobTypesReward = {
            ...jobTypesReward,
            [item.id]: item.rewardPercentage
          }
        })
      }
      state.jobTypesReward = jobTypesReward
      state.jobTypes = [...jobs]
    },
    setJobTypesToNormal (state) {
      let jobTypesReward = {}
      if (state.jobTypesBackup.length > 0) {
        state.jobTypesBackup.forEach(item => {
          jobTypesReward = {
            ...jobTypesReward,
            [item.id]: item.rewardPercentage
          }
        })
      }
      state.jobTypesReward = jobTypesReward
      state.jobTypes = state.jobTypesBackup
    }
  },
  getters: {
    jobTypesGetter: state => state.jobTypes
  },
  actions: {
    async fetchJobTypes ({commit}) {
      const data = await Domain.fetchJobTypes()
      const jobTypes = []
      let permanentObject = {}
      let contractObject = {}
      if (data.length > 0) {
        data.forEach(jobType => {
          if (jobType.name === 'Permanent') {
            permanentObject = {...jobType}
          } else if (jobType.name === 'Contract') {
            contractObject = {...jobType}
          } else {
            jobTypes.push(jobType)
          }
        })
      }
      commit('setJobTypes', [permanentObject, contractObject, ...jobTypes])
      commit('setJobTypesBackup', [permanentObject, contractObject, ...jobTypes])
    },
    async fetchJobTypesRewards ({commit}) {
      try {
        let jobTypesReward = {}
        const data = await Domain.fetchJobTypeReward()
        if (data.length > 0) {
          data.forEach(item => {
            jobTypesReward = {
              ...jobTypesReward,
              [item.id]: item.rewardPercentage
            }
          })
        }
        commit('setJobTypesReward', jobTypesReward)
      } catch (e) {
        console.log('error', e)
      }
    },

    async fetchCategories ({commit}) {
      const data = await Domain.fetchCategories()
      commit('setCategories', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/domain.js